import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';

import {
  Card, BlockStack, InlineStack, Text, Button, TextField,
} from '@shopify/polaris';
import { CheckIcon } from '@shopify/polaris-icons';

import { cartLayoutCreate } from '../../redux/actions/cartLayouts';

const NewCartLayoutForm = ({ addCartLayout, newCartLayout }) => {
  let navigate = useNavigate();

  const [label, setLabel] = useState('');
  const [rows, setRows] = useState(1);
  const [columns, setColumns] = useState(1);
  const [maxItemsPerTote, setMaxItemsPerTote] = useState('');

  useEffect(() => {
    if(newCartLayout) { navigate(-1) };
  }, [newCartLayout, navigate]);

  const submitCartLayout = () => {
    addCartLayout(label, rows, columns, maxItemsPerTote);
  }

  return(
    <SettingsPage
      title="New Cart Layout"
      description="Have questions or need some help? Contact us at support@athousandapps.com"
    >
      <Card>
        <BlockStack gap="400">
          <Text as="h2" variant="headingMd">New Cart Layout</Text>

          <TextField
            requiredIndicator
            label="Cart Layout Name"
            placeholder="Cart Layout Name"
            value={label}
            onChange={setLabel}
            autoComplete="off"
          />

          <TextField
            requiredIndicator
            label="Rows"
            placeholder="Rows"
            type="number"
            min={1}
            value={String(rows)}
            onChange={(value) => setRows(parseInt(value) || 1)}
            autoComplete="off"
          />

          <TextField
            requiredIndicator
            label="Columns"
            placeholder="Columns"
            type="number"
            min={1}
            value={String(columns)}
            onChange={(value) => setColumns(parseInt(value) || 1)}
            autoComplete="off"
          />

          <TextField
            label="Max Items per Tote"
            placeholder="Unlimited"
            type="number"
            min={1}
            value={maxItemsPerTote}
            onChange={setMaxItemsPerTote}
            autoComplete="off"
          />
        </BlockStack>
      </Card>

      <Card>
        <InlineStack align="start">
          <Button
            variant="primary"
            icon={CheckIcon}
            onClick={() => submitCartLayout() }
          >
            Save Cart Layout
          </Button>
        </InlineStack>
      </Card>
    </SettingsPage>
  )
}

const mapStateToProps = state => ({
  newCartLayout: state.cartLayouts.newCartLayout,
});

const mapDispatchToProps = (dispatch) => ({
  addCartLayout: (label, rows, columns, maxItemsPerTote) => dispatch(cartLayoutCreate(label, rows, columns, maxItemsPerTote)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewCartLayoutForm);
